import React from 'react';
import { FadeIn, CTAButton } from './ui';
export function HeroSection() {
  return <section className="bg-cream pt-16 pb-20 px-6 md:pt-24 md:pb-28 overflow-hidden" data-id="element-83">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-84">
        <div className="order-2 lg:order-1" data-id="element-85">
          <FadeIn data-id="element-86">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy leading-tight mb-6" data-id="element-87">
              Metabolismo 40+ Reset: El Método de Ciclado de Cortisol para
              Reactivar tu Quema de Grasa Natural
            </h1>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-88">
            <h2 className="text-xl md:text-2xl text-navy/80 font-medium mb-8 leading-relaxed" data-id="element-89">
              Deja de luchar contra tu cuerpo y aprende a liderar tus hormonas
              para eliminar la grasa abdominal persistente en 21 días.
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-90">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-91">
              Si tienes entre 40 y 50 años, probablemente has notado que las
              dietas que antes te funcionaban hoy no te sirven de nada. Te
              despiertas cansada, tu ropa favorita ya no cierra y sientes que tu
              cuerpo se ha convertido en un extraño que guarda grasa en el
              abdomen sin importar cuánto te esfuerces.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-92">
            <p className="text-lg text-gray-700 mb-10 leading-relaxed font-medium" data-id="element-93">
              No es falta de voluntad. Es un secuestro hormonal. Tu cuerpo no
              está quemando grasa porque está atrapado en un ciclo de
              supervivencia provocado por el cortisol alto y la inflamación.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-94">
            <CTAButton className="w-full md:w-auto" data-id="element-95" />
          </FadeIn>
        </div>

        <div className="order-1 lg:order-2 relative" data-id="element-96">
          <FadeIn delay={0.2} data-id="element-97">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/tDz153gfsXjrrrST47pyTj/metabolismo_2B_40.png" alt="Metabolismo 40+ Reset Mockup" className="w-full h-auto object-cover" data-id="element-99" />
            </div>
            {/* Decorative element */}
            <div className="absolute -z-10 -bottom-6 -right-6 w-full h-full bg-sage rounded-2xl" data-id="element-100"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}